<template>
	<div click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ $t('round_flaw_modal.fix_flaw') }}
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body no-scroll">
					<div class="columns is-mobile">
						<div class="field column">
							<label class="label">{{ $t('round_flaw_modal.flaw') }}</label>
							<div class="control">
								<input
									type="text"
									v-model="flaw.name"
									class="input"
									:placeholder="$t('round_flaw_modal.flaw')"
									disabled
								/>
							</div>
						</div>
						<div class="field column">
							<label class="label">{{ $t('round_flaw_modal.description') }}</label>
							<div class="control">
								<input
									type="email"
									v-model="flaw.description"
									class="input"
									:placeholder="$t('round_flaw_modal.description')"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="columns is-mobile">
						<div class="field column">
							<label class="label">{{ $t('round_flaw_modal.action') }}</label>
							<div class="control">
								<input
									type="text"
									v-model="measure"
									class="input"
									:placeholder="$t('round_flaw_modal.action')"
								/>
							</div>
						</div>
					</div>
				</section>
				<footer class="modal-card-foot">
					<div class="column">
						<button class="button is-dark" @click="save">
							<span class="icon is-info"><i class="fas fa-save"/></span
							><span>{{ $t('round_flaw_modal.fix') }}</span>
						</button>
					</div>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		flaw: Object
	},
	data() {
		return {
			measure: ''
		};
	},
	methods: {
		save() {
			this.$emit('setFixed', this.measure);
		},
		cancel() {
			this.$emit('cancel');
		}
	},
	created() {
		this.measure = this.flaw.measure || '';
	}
};
</script>

<style lang="scss">
.multiselect.panel-select.flaw .multiselect__tags {
  white-space: normal;
}
</style>

<style lang="scss" scoped>
.field.column > .label {
  color: white !important;
}
</style>
